/* duplicate.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M15,16H4.5c-0.6,0-1-0.4-1-1V4.6c0-0.5,0.5-1,1-1H15c0.6,0,1,0.4,1,1V15C16,15.6,15.5,16,15,16z M5.6,14H14
                    V5.5H5.6V14z"/>
                <path class="foreground-gl" d="M2.5,13H1c-0.6,0-1-0.4-1-1V1c0-0.5,0.5-1,1-1h10.4c0.6,0,1,0.4,1,1v2h-2V2H2v9.1h0.5V13z"/>
            </g>
            </svg>
         `,
};
